<template>
  <div class="login-page">
    <v-card class="settings-card login-card" color="#393E46">
      <div class="login-card__brand">
        <v-icon size="56" color="#00ADB5">mdi-electron-framework</v-icon>
        <h1 class="login-card__title">ورود به پنل مدیریت</h1>
        <p class="login-card__subtitle">تامین صنعت</p>
      </div>

      <v-form @submit.prevent="login">
        <v-text-field v-model="admin.email" color="#00ADB5" outlined label="ایمیل" type="email"
                      prepend-inner-icon="mdi-email" dir="ltr"></v-text-field>
        <v-text-field v-model="admin.password" color="#00ADB5" outlined label="رمز عبور" type="password"
                      prepend-inner-icon="mdi-lock" dir="ltr"></v-text-field>
        <v-btn class="btn-primary" type="submit" block large depressed>
          <v-icon left>mdi-login</v-icon>
          ورود
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "LoginView",
  data() {
    return {
      admin: {
        email: null,
        password: null,
      }
    }
  },
  methods: {
    login() {
      this.$store.dispatch("loginAdmin", this.admin)
          .then(() => {
            window.location.replace('/')
          })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background:
    radial-gradient(800px 400px at 85% 10%, rgba(0, 173, 181, 0.22), transparent 60%),
    radial-gradient(600px 400px at 10% 90%, rgba(0, 173, 181, 0.12), transparent 60%);
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 32px 28px 28px;
  margin-bottom: 0;
}

.login-card__brand {
  text-align: center;
  margin-bottom: 28px;
}

.login-card__title {
  font-size: 22px;
  margin-top: 12px;
}

.login-card__subtitle {
  margin: 4px 0 0;
  color: #aab2bd;
  font-size: 14px;
}
</style>
